import React from 'react';
import { SEARCH_TYPE_LIST, SEARCH_TYPE_MAP } from 'app/constants/search';

import * as S from './styles';

const SearchFilter = props => {
  const { selectedFilter, onSelect } = props;

  return (
    <div>
      <S.SearchOptionList>
        {SEARCH_TYPE_LIST.map(searchType => {
          const isSelected = searchType === selectedFilter;
          const title = SEARCH_TYPE_MAP[searchType] || '';

          return (
            <S.SearchOptionItem
              key={`${searchType}-search`}
              onClick={() => onSelect(searchType)}
              isSelected={isSelected}
            >
              {title}
            </S.SearchOptionItem>
          );
        })}
      </S.SearchOptionList>
    </div>
  );
};

export default SearchFilter;
